import {
    SidebarContentBody,
    SidebarContentFooter,
    SidebarContentScrollable,
} from './SidebarContentBody';
import { SidebarContentHeader } from './SidebarContentHeader';
import { SidebarFooter } from './SidebarFooter';

export const getSidebarLayoutInfo = (container: Element) => {
    const header = container.querySelector(SidebarContentHeader);
    const footer = container.querySelector(SidebarFooter);
    const contentFooter = container.querySelector(SidebarContentFooter);
    const body =
        container.querySelector(SidebarContentScrollable) ??
        container.querySelector(SidebarContentBody);

    return {
        headerHeight: header?.getBoundingClientRect()?.height ?? 0,
        footerHeight:
            (footer?.getBoundingClientRect()?.height ?? 0) +
            (contentFooter?.getBoundingClientRect()?.height ?? 0),
        body,
    };
};
